function getLowStockVariantIds() {
  // const lowStockVariantIds = [43694504444121];
  const lowStockVariantIds = [];
  return lowStockVariantIds;
}

function getLowStockMessage() {
  return "Due to high demand, this item will be fulfilled in approximately 14 days on a first-come, first-served basis.";
}
